import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getJoinNetworkKey } from '../../utils/keys';
export const useJoinNetwork = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const joinNetworkKey = getJoinNetworkKey();
    return useMutation((input) => client.auth.joinNetwork(input, fields), { mutationKey: joinNetworkKey, ...useMutationOptions });
};
//# sourceMappingURL=useJoinNetwork.js.map